<template>
  <div style="padding-top: 20px" class="mb-5 policy-info">
    <keep-alive>
      <router-view
        :policyType="policyType"
        :isLoading="isLoading"
        :isAllLoading="isAllLoading"
        :isPropertyLoading="isPropertyLoading"
        :allFamilyDatas="allFamilyDatas"
        :getCathayInsuranceResult="getCathayInsuranceResult"
        :getOtherInsuranceResult="getOtherInsuranceResult"
        :getGroupInsuranceResult="getGroupInsuranceResult"
        :cathayHealthInsurance="cathayHealthInsurance"
        :cathayHurtInsurance="cathayHurtInsurance"
        :cathayNewInsurance="cathayNewInsurance"
        :cathayCarInsurance="cathayCarInsurance"
        :cathayFireInsurance="cathayFireInsurance"
        :otherInsuranceNote="otherInsuranceNote"
        :otherNewInsurance="otherNewInsurance"
        :otherCarInsurance="otherCarInsurance"
        :otherFireInsurance="otherFireInsurance"
      >
        <template slot="type">
          <div>
            <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioL" value="L" v-model="policyType" />
              <label for="radioL">壽險</label>
            </div>
            <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioG" value="G" v-model="policyType" />
              <label for="radioG">團險</label>
            </div>
            <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioA" value="A" v-model="policyType" />
              <label for="radioA">全部壽險保單</label>
            </div>
            <!-- <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioP" value="P" v-model="policyType" />
              <label for="radioP">產險</label>
            </div> -->
            <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioP" value="P" v-model="policyType" />
              <label for="radioP">國泰產險</label>
            </div>
            <div style="margin-right: 20px" class="radio radio-inline">
              <input type="radio" id="radioQ" value="Q" v-model="policyType" />
              <label for="radioQ">其他保單筆記</label>
            </div>
          </div>
        </template>
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { mapMutations, mapGetters } from "vuex";
import {
  getCathayInsurance,
  getOtherInsurance,
  getGroupInsurance,
  getPropertyInsurance,
  getAllFamily,
} from "@/service";

const EMPTY_CATHAY_PROPERTY_INSURANCE = { policies: [], policiesSelfInput: [] };

export default {
  name: "policyInfo",
  mixins: [commonMixin],
  data() {
    return {
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      allFamily: null,
      allFamilyDatas: [],
      //前頁FAMILY DATA
      familyData: JSON.parse(localStorage.userItems),
      //是否顯示查詢GIF
      isLoading: true,
      isAllLoading: true,
      isPropertyLoading: true,
      //國泰壽險資料
      getCathayInsuranceResult: [],
      //同業/建議書
      getOtherInsuranceResult: {},
      //團險
      getGroupInsuranceResult: [],
      checkProperty: false,
      hasProperty: false,
      policyType: "L",
      //國壽健康險
      cathayHealthInsurance: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽傷害險
      cathayHurtInsurance: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽新種險
      cathayNewInsurance: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽車險
      cathayCarInsurance: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //國壽火險
      cathayFireInsurance: EMPTY_CATHAY_PROPERTY_INSURANCE,
      //同業保單筆記
      otherInsuranceNote: [],
      //同業新種險
      otherNewInsurance: [],
      //同業車險
      otherCarInsurance: [],
      //同業火險
      otherFireInsurance: [],
    };
  },
  watch: {
    policyType: function(val) {
      if ((val === "P"||val === "Q") && this.isPropertyLoading) {
        this.getPropertyInsuranceList();
      }
    },
  },
  methods: {
    ...mapMutations(["updateAllFamilyResult", "updateFamilyResultFilter"]),
    ...mapGetters(["AllFamilyResult", "FamilyResultFilter"]),
    async mygetCathayInsurance() {
      const result = await getCathayInsurance(
        this.agidno,
        this.allFamily
      ).catch(() => (this.isLoading = false));
      this.getCathayInsuranceResult = result.data || [];
      this.isLoading = false;
    },
    async mygetOtherInsurance() {
      const result = await getOtherInsurance(this.agidno, this.allFamily);
      this.getOtherInsuranceResult = result.data || {};
    },
    async mygetGroupInsurance() {
      const result = await getGroupInsurance(this.agidno, this.allFamily);
      this.getGroupInsuranceResult = result.group || [];
    },
    getAllInsurance() {
      //壽險
      Promise.all([
        this.mygetCathayInsurance(),
        //同業、建議書
        this.mygetOtherInsurance(),
        //團險
        this.mygetGroupInsurance(),
      ]).finally(() => (this.isAllLoading = false));
    },
    getPropertyInsuranceList() {
      getPropertyInsurance(
        this.$store.state.userInfo.id,
        { 
          CSLIST: this.allFamily,
          CHECKED: this.checkProperty,
          HASDATA: this.hasProperty,
        }
      ).then((result) => {
        if (result.data) {
          this.cathayHealthInsurance = result.data.cathayhealthdataset || EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayHurtInsurance = result.data.cathaycasualitydataset || EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayNewInsurance = result.data.cathaynewdataset || EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayCarInsurance = result.data.cathaymotordataset || EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayFireInsurance = result.data.cathayfiredataset || EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.otherInsuranceNote = result.data.otherinsurancenotedataset || [];
          this.otherNewInsurance = result.data.othernewdataset || [];
          this.otherCarInsurance = result.data.othermotordataset || [];
          this.otherFireInsurance = result.data.otherfiredataset || [];
        } else {
          this.cathayHealthInsurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayHurtInsurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayNewInsurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayCarInsurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.cathayFireInsurance = EMPTY_CATHAY_PROPERTY_INSURANCE;
          this.otherInsuranceNote = [];
          this.otherNewInsurance = [];
          this.otherCarInsurance = [];
          this.otherFireInsurance = [];
        }
        this.isPropertyLoading = false;
      });
    },
    async callApi(fn, done) {
      await fn();
      done();
    },
    init() {
       // 初始化
      if (this.AllFamilyResult().length || this.FamilyResultFilter().length) {
        localStorage.AllFamilyResult = JSON.stringify(this.AllFamilyResult());
        localStorage.FamilyResultFilter = JSON.stringify(this.FamilyResultFilter());
      } else {
        this.updateAllFamilyResult(JSON.parse(localStorage.AllFamilyResult));
        this.updateFamilyResultFilter(
          JSON.parse(localStorage.FamilyResultFilter)
        );
      }
      new Promise((resolve) => {
        //this.updateAllFamilyResult(localStorage.allFamily )
        //          this.updateFamilyResultFilter(localStorage.allFamilyFilter)

        if (localStorage.allFamily) {
          // this.allFamily = localStorage.allFamily.split(',');
          // this.allFamilyDatas = JSON.parse(localStorage.allFamilyDatas)
          getAllFamily(this.familyData.agidno, this.familyData.csidno).then(
            (result) => {
              this.allFamily = localStorage.allFamily.split(",");
              this.allFamilyDatas = result.data;
              this.getAllInsurance();
              resolve();
            }
          );
        } else {
          //   取得所有名單
          getAllFamily(this.familyData.agidno, this.familyData.csidno).then(
            (result) => {
              this.allFamily = result.data.map((x) => x.csidno);
              this.allFamilyDatas = result.data;
              localStorage.allFamily = this.allFamily;

              // localStorage.allFamilyDatas = JSON.stringify(this.allFamilyDatas)
              this.getAllInsurance();
              resolve();
            }
          );
        }
      })
        .then(() => {
          // event listener
          this.$bus.on("cathay-life-insurance.get", (done) =>
            this.callApi(this.mygetCathayInsurance, done)
          );
          this.$bus.on("other-life-insurance.get", (done) =>
            this.callApi(this.mygetOtherInsurance, done)
          );
          this.$bus.on("group-insurance.get", (done) =>
            this.callApi(this.mygetGroupInsurance, done)
          );
          this.$bus.on("property-insurance.get", (done) =>
            this.callApi(this.getPropertyInsuranceList, done)
          );
          this.$bus.on("other-property-insurance.get", (done) =>
            this.callApi(this.getPropertyInsuranceList, done)
          );
          this.$once("hook:destroyed", () => {
            this.$bus.off("cathay-life-insurance.get");
            this.$bus.off("other-life-insurance.get");
            this.$bus.off("group-insurance.get");
            this.$bus.off("property-insurance.get");
            this.$bus.off("other-property-insurance.get");
          });
        })
        .finally(() => {
          this.registerHanlink(); // for 難字更新
          //更新重新載入參數
          this.$route.meta.reload = false;
        });
    },
    initData() {
      //業務員ID
      this.agidno = this.$store.state.userInfo.id;
      this.allFamily = null;
      //前頁FAMILY DATA
      this.familyData = JSON.parse(localStorage.userItems);
      //是否顯示查詢GIF
      this.isLoading = true;
      this.isAllLoading = true;
      this.isPropertyLoading = true;
      //國泰壽險資料
      this.getCathayInsuranceResult = [];
      //同業/建議書
      this.getOtherInsuranceResult = {};
      //團險
      this.getGroupInsuranceResult = [];
      this.policyType = "L"
    },
  },
  mounted() {
    this.init();
  },
  created() {
    this.checkProperty = this.$route.params.checkProperty || false;
    this.hasProperty = this.$route.params.hasProperty || false;
  },
  activated() {
    //判斷是否需刷新
    //確保資料參數更新後再執行init方法
    if (this.$route.meta.reload) {
      new Promise((resolve) => {
        this.initData();
        resolve();
      }).then(() => {
        this.init();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.policy-info /deep/ {
  .thBorderCustOther {
    height: 48px;
    border: #0f82b5 1px solid !important;
  }
  .thBorderCustSuggest {
    height: 48px;
    border: #de4054 1px solid !important;
  }
  .pre-formatted {
    white-space: pre-line;
  }
  .policyBlue {
    color: #1442c4;
  }
  .primary {
    background-color: white;
  }
  .fw-normal {
    font-weight: normal;
  }
  .font-13 {
    font-size: 13px;
  }
  .font-20 {
    font-size: 20px;
  }
  .table.datatable tbody tr.bg-orange {
    background: #feeedd;
  }
  .margin-vertical-5 {
    margin-bottom: 25px;
  }
}
</style>
